<template>

    <div class="icon">
        <i v-if="type === 'email'" class="fas fa-at"></i>
        <i v-if="type === 'phone'" class="fas fa-phone"></i>
        <i v-if="type === 'name'" class="fas fa-signature"></i>
        <i v-if="type === 'first_name'" class="fas fa-signature"></i>
        <i v-if="type === 'last_name'" class="fas fa-signature"></i>
        <i v-if="type === 'text_short'" class="fas fa-text"></i>
        <i v-if="type === 'text_long'" class="fas fa-align-left"></i>
        <i v-if="type === 'dropdown'" class="fas fa-th-list"></i>
        <i v-if="type === 'checkbox'" class="fas fa-check"></i>
    </div>

</template>

<style scoped lang="scss">

    .icon {
        align-items: center;
        background: $color-text;
        border-radius: 3px;
        color: #fff;
        display: flex;
        height: 40px;
        justify-content: center;
        width: 40px;
    }

</style>

<script>

export default {

    props: {
        type: {
            type: String,
            required: true,
        },
    },

}

</script>
